import { Component } from '@angular/core';

@Component({
  selector: 'app-experiment-content',
  templateUrl: './experiment-content.component.html',
  styleUrl: './experiment-content.component.css'
})

export class ExperimentContentComponent {

}
